import React from "react";
import { observer } from "mobx-react";

import { Dialog } from "primereact/dialog";

import { useNotificationsStore } from "..";
import { NotificationNotesModalProps } from "api";

export const NotificationNotesModal: React.FC<NotificationNotesModalProps> =
  observer(function (props) {
    const { notificationGlobalStore, messageStore, ...store } =
      useNotificationsStore();

    return (
      <>
        <Dialog
          header={props.notification?.notificationCategoryName}
          visible={notificationGlobalStore.showNotesModal}
          breakpoints={{ "960px": "75vw" }}
          style={{ width: "50vw" }}
          onHide={() => (notificationGlobalStore.showNotesModal = false)}
        >
          <div className="p-grid p-mt-2 p-mb-2">
            <div className="p-col-12">
              <span className="p-text-bold">
                {props.notification?.caseNumber}
              </span>{" "}
              {props.notification?.caseCaption}
            </div>
            <div className="p-col-12">
              <span className="p-text-bold">Notes:</span>
            </div>
            <div className="p-col-12">
              <div className="notes-container">
                {props.notification?.description}
              </div>
            </div>
          </div>
        </Dialog>
      </>
    );
  });
